import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_OLD, offerIncludes, offerRows } from '../data/religione';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1hofsa5aetvca">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="tyldhi6j5wpe">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="u0oaim63oq3m">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="p11z8i9u1jxg">
            Scopri il tuo pacchetto completo <em className="text-red-300" data-id="element-230" data-mp="13uy4u9elrygz">ARTE PRONTA™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="yx525qcidmlg">
            Le tue lezioni di arte pronte in soli 5 minuti. Entra in aula con tutto pronto.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="2ac1sr4occjux" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="pjz4ly943o0d">
          <img src={PRODUCT_IMAGE} alt="ARTE PRONTA™: 9 volumi + 5 bonus" className="mx-auto mb-6 w-full max-w-[16rem] drop-shadow-xl lg:hidden" data-id="element-234" data-mp="zhvdejeku6vb" />
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-235" data-mp="13j746s96sy53">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-236" data-mp="6vkav37etvvv">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-237" data-mp="bqpt9s1lssf7">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-238" data-mp="ftm8d8rxq6ee">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-239" data-mp="kmfd3wneleqh" />
                </span>
                <span data-id="element-240" data-mp="3k6t4g7rxcz8a">
                  <span className="block font-medium leading-snug" data-id="element-241" data-mp="3o9z8r9vh8gc4">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-242" data-mp="vfqxu4aubgt9">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-243" data-mp="qg4inpbgbqht">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-244" data-mp="106pex63nkixk">
              Prezzo di lancio <span className="ml-1 text-slate-900/50" data-id="element-245" data-mp="cgv56xemrahj">invece di <s data-id="element-246" data-mp="cho3rb3fqtol">{PRICE_OLD}</s></span>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-247" data-mp="7i1okw41r3d5">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-248" data-mp="lj4c7daowlq6">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-249" data-mp="hi2bst51e3mm" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Voglio il pacchetto completo" className="mt-8 w-full" data-id="element-250" data-mp="1sveircw3f2d0" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-251" data-mp="1sxhac1cw93ju">
            {offerIncludes.map(item => <li key={item} data-id="element-252" data-mp="25e0elprk6644">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}